import type { SerializedNote, UndoState } from './types';

const MAX_STATES = 100;

export class UndoManager {
  private undoStack: UndoState[] = [];
  private redoStack: UndoState[] = [];

  push(notes: SerializedNote[]): void {
    this.undoStack.push({
      notes: notes.map(n => ({ ...n })),
      timestamp: Date.now(),
    });
    if (this.undoStack.length > MAX_STATES) {
      this.undoStack.shift();
    }
    this.redoStack = [];
  }

  undo(currentNotes: SerializedNote[]): SerializedNote[] | null {
    if (this.undoStack.length === 0) return null;
    this.redoStack.push({
      notes: currentNotes.map(n => ({ ...n })),
      timestamp: Date.now(),
    });
    return this.undoStack.pop()!.notes;
  }

  redo(currentNotes: SerializedNote[]): SerializedNote[] | null {
    if (this.redoStack.length === 0) return null;
    this.undoStack.push({
      notes: currentNotes.map(n => ({ ...n })),
      timestamp: Date.now(),
    });
    return this.redoStack.pop()!.notes;
  }

  get canUndo(): boolean {
    return this.undoStack.length > 0;
  }

  get canRedo(): boolean {
    return this.redoStack.length > 0;
  }

  clear(): void {
    this.undoStack = [];
    this.redoStack = [];
  }
}
